import { FormUnit } from "@suse-o11y/signal/form";

import { identity } from "~/tools/identity";
import { isStringDirty } from "~/tools/is-string-dirty";

import { dashboardVariableLabelName } from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";

export type FormState = FormUnit<string, ReadonlyArray<string>>;

export const Processor: FormProcessor<FormState, undefined | string> = {
	fromSpec: (labelName) =>
		FormUnit(labelName ?? "", {
			isInputDirty: isStringDirty,
			schema: dashboardVariableLabelName,
		}),

	toSpec: identity,
};
